// extracted by mini-css-extract-plugin
export default {"container":"iKiELdINlN2jlvsk74qt","headingContainer":"P3o3GaM_qMXp0LlfT6_4","iconContainer":"ph4dcOjzeMMwQllkyXTl","dividerContainer":"Iwi12I8T4dICbzo9PiZp"};